/* eslint-disable no-undef */
import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import LoadingBar from "react-top-loading-bar";
import 'react-tabs/style/react-tabs.css';

import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import TabMenuAccess from "./tab/tabMenuAccess";
import TabMember from "./tab/tabMember";
import TabFormAccess from "./tab/tabFormAccess";
import TabCompanyAccess from "./tab/tabCompanyAccess";
import TabDataAccess from "./tab/tabDataAccessDatatables";
import PopUp from '../../../pages/PopUpAlert';

const accessData = [
    {
        value: 'Allowed',
        label: 'Allowed'
    },
    {
        value: 'Banned',
        label: 'Banned'
    }
]

class FormEditRole extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data ? props.data : {
                roleId: "",
                companyId: ""
            },
            requestData: {
                action: "UPDATE"
            },
            requestCompanyAccess: [],
            requestMenuAccess: [],
            requestFormAccess: [],
            requestDataAccess: [],
            loadSave: false,
            tabIndex: 0,
            savePopUpVisible: false,
            actionSave: false,
        }
    }

    componentDidMount() {
        // console.log(JSON.stringify(this.props.data, null, 2))
        this.getCompanyDdl();
        this.setDataValue(this.props.data);
    }

    setDataValue(data) {
        let dataCompany = {
            value: data.companyId,
            label: data.companyName
        }
        let dataAccessType = {
            value: data.accessType,
            label: data.accessType
        }
        this.setState({
            requestData: {
                ...this.state.requestData,
                roleId: data.roleId,
                companyId: data.companyId,
                roleCode: data.roleCode,
                roleName: data.roleName,
                accessType: data.accessType,
                memberTypeId: data.memberTypeId,
                isLock: data.isLock ? data.isLock : 0,
                status: data.status
            },
            companyIdSelect: dataCompany,
            accessTypeSelect: dataAccessType
        });
    }

    getCompanyDdl() {
        let payload = {
            companyGroupId: this.state.companyGroupId,
        }
        Api.create('MASTERDATA_EKSAD').postGetCompanyDdl(payload).then(
            (res) => {
                if (res.ok && res.data.status === 'S') {
                    let array = []
                    res.data.data && res.data.data.map((item) => {
                        array.push({
                            value: item.companyId,
                            label: item.companyName
                        })
                    })
                    this.setState({
                        companyData: array
                    })
                }
            })
    }

    startFetch = () => {
        this.LoadingBar.continousStart();
    };

    onFinishFetch = () => {
        if (typeof this.LoadingBar === 'object') this.LoadingBar.complete();
    };

    onChangeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            requestData: {
                ...this.state.requestData,
                [name]: value
            }
        })
    }

    onChangeCombo = (event, name) => {
        let value = event.value;
        this.setState({
            requestData: { ...this.state.requestData, [name]: value, [name + "Select"]: event }
        });
    }

    validation = (data) => {
        // console.log(JSON.stringify(this.state.requestData, null, 2))
        if (!this.state.requestData.roleName.trim()) {
            return alert('Role Name is Required.')
        } else {
            this.isLoad(true);
            this.onClickSave();
        }
    }

    requestDataCompany = async (response) => {
        // console.log("Ini Company Access : " + JSON.stringify(response, null, 2))
        this.setState({
            requestCompanyAccess: response,
            actionSave: true
        })
    };

    requestDataMenu = async (response) => {
        // console.log("Ini Menu Access : " + JSON.stringify(response, null, 2))
        this.setState({
            requestMenuAccess: response,
            actionSave: true
        })
    };

    requestDataForm = async (response) => {
        // console.log("Ini Form Access : " + JSON.stringify(response, null, 2))
        this.setState({
            requestFormAccess: response,
            actionSave: true
        })
    };

    requestDataAccess = async (response) => {
        // console.log("Ini Data Access : " + JSON.stringify(response, null, 2))
        this.setState({
            requestDataAccess: response,
            actionSave: true
        })
    };

    setPayload = (response) => {
        let payload = {
            roleId: this.props.data.roleId,
            data: response.length > 0 ? response : []
        }
        return payload;
    }

    isLoad(visible) {
        this.setState({ loadSave: visible })
    }

    onClickSave = () => {
        let payload = { ...this.state.requestData }
        payload.roleName = this.state.requestData.roleName.trim();

        Api.create('MASTERDATA_EKSAD').postSaveRole(payload).then(
            (res) => {
                if (res.ok && res.data.status === 'S') {
                    this.isLoad(false);
                    this.openSavePopUp();

                    if (this.state.data.accessType === 'Allowed') {
                        if (this.state.actionSave) {
                            this.saveAccessTypeAllowed()
                        }
                    } else {
                        if (this.state.actionSave) {
                            this.saveAccessTypeBanned()
                        }
                    }
                }
            })

    }

    saveAccessTypeAllowed = () => {
        if (this.state.tabIndex === 1) {
            Api.create('MASTERDATA_EKSAD').postSaveRoleMenuAllowed(this.setPayload(this.state.requestMenuAccess))
        }
        if (this.state.tabIndex === 2) {
            Api.create('MASTERDATA_EKSAD').postSaveRoleFormAllowed(this.setPayload(this.state.requestFormAccess))
        }
        if (this.state.tabIndex === 3) {
            Api.create('MASTERDATA_EKSAD').postSaveRoleCompanyAllowed(this.setPayload(this.state.requestCompanyAccess))
        }
        if (this.state.tabIndex === 4) {
            Api.create('MASTERDATA_EKSAD').postSaveRoleDataAllowed(this.setPayload(this.state.requestDataAccess))
        }
    }

    saveAccessTypeBanned = () => {
        if (this.state.tabIndex === 1) {
            Api.create('MASTERDATA_EKSAD').postSaveRoleMenuBanned(this.setPayload(this.state.requestMenuAccess))
        }
        if (this.state.tabIndex === 2) {
            Api.create('MASTERDATA_EKSAD').postSaveRoleFormBanned(this.setPayload(this.state.requestFormAccess))
        }
        if (this.state.tabIndex === 3) {
            Api.create('MASTERDATA_EKSAD').postSaveRoleCompanyBanned(this.setPayload(this.state.requestCompanyAccess))
        }
        if (this.state.tabIndex === 4) {
            Api.create('MASTERDATA_EKSAD').postSaveRoleDataBanned(this.setPayload(this.state.requestDataAccess))
        }
    }

    handlePopUp = () => {
        this.setState({
            savePopUpVisible: false,
        })
    }

    openSavePopUp = () => {
        this.setState({ savePopUpVisible: !this.state.savePopUpVisible });
    };

    render() {
        return (
            <div>
                <div className="app-popup app-popup-show">
                    <div className="padding-top-20px" />
                    <div className="popup-content background-white border-radius" style={{ width: "1200px" }}>
                        <div className="popup-panel grid grid-2x">
                            <div className="col-1">
                                <div className="popup-title">
                                    <div className="flexrow"
                                        style={{ flexDirection: 'row', display: 'flex', justifyContent: 'flex-start' }}>
                                        <div style={{
                                            width: '90px',
                                            backgroundColor: this.props.data.accessType === 'Allowed' ? '#00B9F2'
                                                : 'red',
                                            borderRadius: 5,
                                            justifyContent: 'center'
                                        }}>
                                            <div style={{ marginLeft: '17px', color: 'white' }}>
                                                {this.props.data.accessType}
                                            </div>
                                        </div>
                                        <div className="margin-left-15px">
                                            {"Roles : "} {this.props.data.roleCode}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-2 content-right">
                                <button
                                    className="btn btn-circle btn-grey"
                                    onClick={this.props.onClickClose}
                                >
                                    <i className="fa fa-lg fa-times" />
                                </button>
                            </div>
                        </div>
                        <div className="border-bottom padding-15px grid grid-1x grid-mobile-none gap-15px">
                            <div className="column-1">
                                {this.props.formUser ? this.renderFromUser() : this.renderForm()}
                            </div>
                        </div>

                        <div className="padding-15px">
                            <div className="grid grid-2x">
                                <div className="col-1" />
                                <div className="col-2 content-right">
                                    {
                                        (this.props.type !== 'view' && this.props.data.isLock != 1) &&
                                        <button className="btn btn-red" type="submit" disabled={this.state.loadSave}
                                            onClick={
                                                () => {
                                                    this.validation(this.state.data)
                                                }}>
                                            <span>{!this.state.loadSave ? 'SAVE' : 'Saving...'}</span>
                                        </button>
                                    }
                                    <button
                                        style={{ marginLeft: "15px" }}
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={this.props.onClickClose}
                                    >
                                        <span>CLOSE</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.savePopUpVisible &&
                    <PopUp type={'save'} class={'app-popup app-popup-show'} onClick={this.handlePopUp.bind(this)} />}
            </div>
        )
    }

    renderForm() {
        return (
            <div>
                <div>
                    <div className="grid grid-3x">
                        <div className="col-2" style={{ marginRight: "20px" }}>
                            <SimpleDDL
                                box={'search'}
                                label={'Company'}
                                options={this.state.companyData}
                                onChange={(e) => this.onChangeCombo(e, "companyId")}
                                disabled={true}
                                value={this.state.companyIdSelect}
                            />
                            <SimpleInput
                                label={"Role Code"}
                                mandatory={"true"}
                                name={"roleCode"}
                                value={this.state.requestData.roleCode}
                                onChange={(e) => this.onChangeInput(e)}
                                readOnly={true}
                            />
                        </div>
                        <div className="col-2" style={{ marginLeft: "12px" }}>
                            <SimpleInput
                                label={"Role Name"}
                                mandatory={"true"}
                                name={"roleName"}
                                value={this.state.requestData.roleName}
                                onChange={(e) => this.onChangeInput(e)}
                                readOnly={this.props.type === 'view' || this.state.data.isLock == 1}
                                required
                            />
                            <SimpleDDL
                                box={'search'}
                                label={'Access Type'}
                                options={accessData}
                                onChange={(e) => this.onChangeCombo(e, "accessType")}
                                value={this.state.accessTypeSelect}
                                disabled={true}
                            />
                        </div>
                        <div style={{ marginLeft: '40px' }} className="margin-bottom-20px">
                            <div className="margin-5px">
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>
                                        Status
                                    </h4>
                                </div>
                            </div>
                            <div className="margin-15px">
                                <label className="radio">
                                    <input
                                        type="checkbox"
                                        disabled={this.props.type === 'view' || this.state.data.isLock == 1}
                                        checked={this.state.requestData.status === "Active"}
                                        onChange={(e) => {
                                            this.setState({
                                                requestData: {
                                                    ...this.state.requestData,
                                                    status: e.target.checked ? "Active" : "Inactive"
                                                }
                                            });
                                        }}
                                    />
                                    <span className="checkmark" />
                                    <div className="txt-site txt-11 txt-bold txt-main">
                                        <h4>{this.state.requestData.status}</h4>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    {this.renderTabs()}
                </div>
            </div>
        )
    }

    renderFromUser() {
        return (
            <div>
                <div className="grid grid-2x">
                    <div className="col-2" style={{ marginRight: "20px" }}>
                        <SimpleInput
                            label={"Role Code"}
                            mandatory={"true"}
                            name={"roleCode"}
                            value={this.state.requestData.roleCode}
                            onChange={(e) => this.onChangeInput(e)}
                            readOnly={true}
                        />
                        <SimpleDDL
                            box={'search'}
                            label={'Access Type'}
                            options={accessData}
                            onChange={(e) => this.onChangeCombo(e, "accessType")}
                            value={this.state.accessTypeSelect}
                            disabled={true}
                        />
                    </div>
                    <div className="col-2" style={{ marginLeft: "12px" }}>
                        <SimpleInput
                            label={"Role Name"}
                            mandatory={"true"}
                            name={"roleName"}
                            value={this.state.requestData.roleName}
                            onChange={(e) => this.onChangeInput(e)}
                            readOnly={this.props.type === 'view'}
                            required
                        />
                    </div>
                </div>
                {this.renderTabs()}
            </div>
        )
    }

    renderTabs() {
        return this.state.data.isLock != 1 ? (
            <div className="padding-tbl-monitoring">
                <LoadingBar onRef={ref => (this.LoadingBar = ref)} />
                <Tabs className="padding-top-15px" selectedIndex={this.state.tabIndex} onSelect={(tabIndex) => this.setState({ tabIndex })}>
                    <TabList>
                        <Tab>Member</Tab>
                        <Tab>Menu Access</Tab>
                        <Tab>Form Access</Tab>
                        <Tab>Company Access</Tab>
                        <Tab>Data Access</Tab>
                    </TabList>
                    <TabPanel>
                        <TabMember
                            type={this.props.type}
                            data={this.state.data}
                        />
                    </TabPanel>
                    <TabPanel>
                        <TabMenuAccess
                            type={this.props.type}
                            requestData={this.requestDataMenu.bind(this)}
                            data={this.state.data}
                        />
                    </TabPanel>
                    <TabPanel>
                        <TabFormAccess
                            type={this.props.type}
                            requestData={this.requestDataForm.bind(this)}
                            data={this.state.data}
                        />
                    </TabPanel>
                    <TabPanel>
                        <TabCompanyAccess
                            type={this.props.type}
                            requestData={this.requestDataCompany.bind(this)}
                            data={this.state.data}
                        />
                    </TabPanel>
                    <TabPanel>
                        <TabDataAccess
                            type={this.props.type}
                            requestData={this.requestDataAccess.bind(this)}
                            data={this.state.data}
                        />
                    </TabPanel>
                </Tabs>
            </div>
        ) : (
            <div className="padding-tbl-monitoring">
                <LoadingBar onRef={ref => (this.LoadingBar = ref)} />
                <Tabs className="padding-top-15px">
                    <TabList>
                        <Tab>Member</Tab>
                    </TabList>
                    <TabPanel>
                        <TabMember
                            type={this.props.type}
                            data={this.state.data}
                            isLock={this.state.data.isLock}
                        />
                    </TabPanel>
                </Tabs>
            </div>
        )
    }
}

export default FormEditRole;